export const initialLocationsListState= {
    data: {
        locations: [],
        totalElements: 0
    },
    loading: false
}